import { ApiCall } from '../../fromKotlin/nk';

export interface TaklitProduct {
    id: number;
    name: string;
    pricea: number;
    priceb: number;
    date: string;
}

const deserializeTaklitProduct = (ko: any): TaklitProduct => ({
    id: Number(ko.id ?? 0),
    name: String(ko.name ?? ''),
    pricea: Number(ko.pricea ?? 0),
    priceb: Number(ko.priceb ?? 0),
    date: String(ko.date ?? ''),
});

/** Same as Android GET_TAKLIT_PRODUCTS + buildTaklitProducts — loads list for date into local DB cache. */
export const fetchTaklitProducts = async (date: string): Promise<TaklitProduct[]> => {
    const req = new ApiCall('GET_TAKLIT_PRODUCTS');
    req.putParam('date', date);
    const result = await req.execute();
    if (!result || result.first == null) return [];
    const list = result.first;
    if (!list || (typeof list.size === 'number' && list.size === 0)) return [];
    if (typeof list.toArray === 'function') {
        return list.toArray().map(deserializeTaklitProduct);
    }
    return [];
};

/** Same as Android CALCULATE_TAKLIT — recalculates server-side; call fetchTaklitProducts after. */
export const calculateTaklit = async (): Promise<boolean> => {
    const req = new ApiCall('CALCULATE_TAKLIT');
    const result = await req.execute();
    if (result == null) return false;
    return result.second?.name === 'SUCCESS';
};
